import React from 'react'
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import { StyledEngineProvider } from '@mui/material/styles'
import { ThemeProvider } from '@mui/material/styles'
import { ConnectedRouter } from 'connected-react-router'
import { history } from './redux/reducers'
import { Helmet } from 'react-helmet'
import { CookiesProvider } from 'react-cookie'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment'
import { MsalProvider } from '@azure/msal-react'
import { theme } from './styles/theme.js'
import AuthApp from './indexApp.js'
import { msalInstance } from './authConfig.js'
import './index.css'
import 'leaflet/dist/leaflet.css'
import config from './config.json'
import { configureStore } from './redux/store.js'
import { startVersionWatcher } from './versionGuard.js'

const store = configureStore()
if (process.env.NODE_ENV === 'production') {
  startVersionWatcher(600000) // 10 min
}

const container = document.getElementById('root')
const root = createRoot(container)

const appTree = (
  <Provider store={store}>
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>
        <ConnectedRouter history={history}>
          <CookiesProvider>
            <LocalizationProvider dateAdapter={AdapterMoment}>
              <Helmet
                htmlAttributes={{ style: 'height: 100%; overflow: hidden;' }}
                bodyAttributes={{
                  style: `background-color: ${theme.palette.generalUi.background}; margin: 0; height: 100%;`,
                }}
              >
                <title>{config.appTitle}</title>
                <link rel="preconnect" href="https://fonts.gstatic.com" />
                <link
                  href="https://fonts.googleapis.com/css2?family=Open+Sans&display=swap"
                  rel="stylesheet"
                />
              </Helmet>
              <AuthApp />
            </LocalizationProvider>
          </CookiesProvider>
        </ConnectedRouter>
      </ThemeProvider>
    </StyledEngineProvider>
  </Provider>
)

root.render(
  msalInstance ? (
    <MsalProvider instance={msalInstance}>{appTree}</MsalProvider>
  ) : (
    appTree
  ),
)
